/* eslint-disable no-new */
import Swiper from 'swiper';

var Myswiper =
/** @class */
function () {
  function Myswiper(name) {
    this.className = name;
    this.swiperSlide = '.swiper-slide';
    this.pagination = '.swiper-pagination';
    this.buttonNext = '.swiper-button-next';
    this.buttonPrev = '.swiper-button-prev';
    this.init();
  }

  Myswiper.prototype.init = function () {
    var _a = this,
        className = _a.className,
        swiperSlide = _a.swiperSlide;

    console.log(123, className, swiperSlide);

    if ($(className + " " + swiperSlide).length > 1) {
      console.log(5);
      this.swiper();
    }
  };

  Myswiper.prototype.swiper = function () {
    var _a = this,
        className = _a.className,
        pagination = _a.pagination,
        buttonNext = _a.buttonNext,
        buttonPrev = _a.buttonPrev;

    new Swiper(className, {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      pagination: {
        el: pagination,
        clickable: true
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev
      },
      centeredSlides: true
    });
  };

  return Myswiper;
}();

export default Myswiper;